import { LG } from "./liquidGlass";

export const TYPOGRAPHY_STYLES = {
  rubikLarge: {
    fontFamily: "inherit",
    fontSize: "0.9rem",
    fontWeight: 400,
    letterSpacing: "0.04em",
    color: LG.color.text,
  },
  rubikMedium: {
    fontFamily: "inherit",
    fontSize: "0.8rem",
    fontWeight: 600,
    color: LG.color.text,
  },
  rubikSmall: {
    fontFamily: "inherit",
    fontSize: "0.75rem",
    fontWeight: 400,
    color: LG.color.textSecondary,
  },
  rubikBold: {
    fontFamily: "inherit",
    fontSize: "0.9rem",
    fontWeight: 700,
    color: LG.color.text,
  },
  label: {
    fontFamily: "inherit",
    fontSize: "0.7rem",
    fontWeight: 600,
    letterSpacing: "0.08em",
    textTransform: "uppercase" as const,
    color: LG.color.textSecondary,
  },
};
